import { Badge, Button, Col, Divider, Icon, Modal, Row, Tag } from 'antd';
import React, { Component } from 'react';
import Moment from 'react-moment';
import {
  PAYMENT_METHOD_BANKTRANSFER,
  getPaymentBankTagColor,
  getPaymentMethodTagColor,
  getPaymentMethodTagName,
} from '../../config/payment';
import ResubmitKYCModal from './resubmit-kyc.modal';

Moment.globalLocal = false;

const DATE_TO_FORMAT = 'MMM DD YYYY HH:mm:ss';

class PaymentDetail extends Component {
  state = {
    kycAdminReasonList: [],
    visibleResubmitKYCModal: false,
    visibleSlipImage: false,
    currentSlipImage: '',
  };

  grandTotal = (d) => {
    if (!d) {
      return '';
    }
    let total = 0;
    if (d.is_vat) {
      total = d.amount * 1.07;
    } else {
      total = d.amount || 0;
    }
    return total.toLocaleString();
  };

  actualAmount = (d) => {
    if (!d) return '';

    let amount = d.amount || 0;

    const promotionSummaryDetail = d.promotion_summary_detail;
    if (d.promotion_id > 0 && promotionSummaryDetail)
      amount = promotionSummaryDetail.total_amount || 0;

    return amount.toLocaleString();
  };

  vat = (amount, isVat) => {
    if (!isVat) return '-';

    return `$${(amount * 0.07 || 0).toLocaleString()}`;
  };

  fee = (amount) => {
    if (!amount) return '-';
    return `$${amount.toLocaleString()}`;
  };

  handleResubmitKYCModal = (visibleResubmitKYCModal = false) => {
    this.setState({ visibleResubmitKYCModal });
  };

  convertDateTimeToHuman = (t) => {
    if (!t || isNaN(+t) || t < 1) return '-';
    return (
      <Moment unix tz="Etc/UTC" format={DATE_TO_FORMAT}>
        {t}
      </Moment>
    );
  };

  getBadgeStatus = (status) => {
    let badge = 'warning';
    let statusTxt = 'Fail';
    if (status === 'confirm') {
      badge = 'success';
      statusTxt = 'Approved';
    } else if (status === 'to_approve') {
      badge = 'processing';
      statusTxt = 'Wating for approve';
    } else if (status === 'reject') {
      badge = 'error';
      statusTxt = 'Rejected';
    }

    return <Badge status={badge} text={statusTxt} />;
  };

  getPaymentBankTag = (bank) => {
    const tagColor = getPaymentBankTagColor(bank);
    return <Tag color={tagColor}>{bank}</Tag>;
  };

  getPaymentMethodTag = (method) => {
    const tagName = getPaymentMethodTagName(method);
    const tagColor = getPaymentMethodTagColor(method);
    return <Tag color={tagColor}>{tagName}</Tag>;
  };

  getBadgePackage = (pd) => {
    let productTag;
    const pdName = pd.Name;
    const pdCountry = pd.CountryAbbr;
    if (pd.Type === 'sms') {
      productTag = (
        <Tag color="#5da8e4">
          [SMS] {pdCountry} {pdName}
        </Tag>
      );
    } else if (pd.Type === 'viber') {
      productTag = <Tag color="#938ff1">[Viber] {pdName}</Tag>;
    } else if (pd.Type === 'whatsapp') {
      productTag = <Tag color="#4eba55">[WhatsApp] {pdName}</Tag>;
    }

    return productTag;
  };

  joinArrStr = (arrStr) => {
    if (!Array.isArray(arrStr)) return '-';
    else if (arrStr.length < 1) return '-';

    return arrStr.join(', ');
  };

  render() {
    const {
      visibleDetailModal,
      onCloseDetailModal,
      data: d,
      approved,
      viewImageSlip,
    } = this.props;
    const kyc_logs_detail = d.kyc_logs_detail || {};
    const memberDetail = d.member_detail || {};
    const approvedLabelTxt = d.status === 'reject' ? 'Reject' : 'Approve';
    const isBankTransfer = d.method === PAYMENT_METHOD_BANKTRANSFER;
    const isPackageTier = d.product_package_id > 0;
    const productDetail = isPackageTier && d.product_detail;
    const isViberChannelName = d.vbcr;

    let promotionTxt = '-';
    if (d.promotion_summary_detail) {
      const productType = d.promotion_summary_detail.product_type
      if (productType) {
        promotionTxt = `$${d.promotion_summary_detail.rate_bonus} (${d.promotion_summary_detail.name})`
      } else {
        const promotionReceived = d.amount * (d.promotion_summary_detail.rate_bonus / 100) || 0;
        promotionTxt = `$${promotionReceived.toLocaleString()} (${d.promotion.replace(/_/g, ' ',)} ${d.promotion_summary_detail.detail})`;
      }
    }

    let adminName = '-';
    if (d.approved_by > 0 && d.admin_detail) {
      adminName = d.admin_detail.firstname
        ? d.admin_detail.firstname + ' ' + d.admin_detail.lastname
        : d.admin_detail.email;
    }

    let footer = [];

    if (d.status === 'to_approve') {
      footer.push(
        <Button key="approved" type="primary" onClick={() => approved(d.id)}>
          Approve
        </Button>,
      );

      if (kyc_logs_detail.id) {
        const disabled = kyc_logs_detail.status !== 'to_approve';
        footer.push(
          <Button
            key="resubmit"
            disabled={disabled}
            onClick={() => this.handleResubmitKYCModal(true)}
            style={
              disabled ? undefined : { backgroundColor: 'rgb(255 173 24)', color: '#fff' }
            }
          >
            Notify customer to do KYC
          </Button>,
        );
      }
    }

    footer.push(
      <Button key="cancel" onClick={onCloseDetailModal}>
        Cancel
      </Button>,
    );

    return (
      <div>
        <Modal
          className="payment-detail-modal"
          visible={visibleDetailModal}
          title={`Order Details - PAYMENT${d.id}`}
          onCancel={onCloseDetailModal}
          maskClosable={false}
          footer={footer}
        >
          <Divider className="my-divider" dashed orientation="left">
            Payment Information
          </Divider>
          <div>
            <Row>
              <Col span={10}>Payment Method</Col>
              <Col span={14}>{this.getPaymentMethodTag(d.method)}</Col>
            </Row>
            <Row>
              <Col span={10}>Invoice No.</Col>
              <Col span={14}>{d.invoice_no}</Col>
            </Row>
            <Row>
              <Col span={10}>Order No.</Col>
              <Col span={14}>{d.order_no}</Col>
            </Row>
            <Row>
              <Col span={10}>Transaction Date (UTC)</Col>
              <Col span={14}>{this.convertDateTimeToHuman(d.created)}</Col>
            </Row>
            {!isBankTransfer ? (
              <Row>
                <Col span={10}>Successful Transaction (UTC)</Col>
                <Col span={14}>{this.convertDateTimeToHuman(d.hook_update)}</Col>
              </Row>
            ) : null}
            <Row>
              <Col span={10}>Amount</Col>
              <Col span={14}>${d.amount}</Col>
            </Row>
            <Row>
              <Col span={10}>VAT</Col>
              <Col span={14}>{this.vat(d.amount, d.is_vat)}</Col>
            </Row>
            <Row>
              <Col span={10}>Fee</Col>
              <Col span={14}>{this.fee(d.fee)}</Col>
            </Row>
            <Row>
              <Col span={10}>Grand Total</Col>
              <Col span={14}>${this.grandTotal(d)}</Col>
            </Row>
            <Row>
              <Col span={10}>Bonus</Col>
              <Col span={14}>{promotionTxt}</Col>
            </Row>
            <Row>
              <Col span={10}>Actual Amount</Col>
              <Col span={14}>${this.actualAmount(d)}</Col>
            </Row>
          </div>

          {isBankTransfer ? (
            <span>
              <Divider className="my-divider" dashed orientation="left">
                Bank Transfer Information
              </Divider>
              <div>
                <Row>
                  <Col span={10}>Payment Confirmation Time</Col>
                  <Col span={14}>{this.convertDateTimeToHuman(d.confirm_date)}</Col>
                </Row>
                <Row>
                  <Col span={10}>Bank</Col>
                  <Col span={14}>{this.getPaymentBankTag(d.bank)}</Col>
                </Row>
                <Row>
                  <Col span={10}>Fee</Col>
                  <Col span={14}>${d.fee}</Col>
                </Row>
                <Row>
                  <Col span={10}>Transfer Date</Col>
                  <Col span={14}>{this.convertDateTimeToHuman(d.transfer_date)}</Col>
                </Row>
                <Row>
                  <Col span={10}>Slip</Col>
                  <Col span={14}>
                    <a href="#" onClick={() => viewImageSlip(d.slip || '')}>
                      <Icon type="file-image" theme="twoTone" />
                      <span style={{ marginLeft: '5px' }}>
                        (Click to view transfer slip)
                      </span>
                    </a>
                  </Col>
                </Row>
              </div>
            </span>
          ) : null}

          <Divider className="my-divider" dashed orientation="left">
            Status
          </Divider>
          <div style={{ textAlign: 'center' }}>{this.getBadgeStatus(d.status)}</div>

          <Divider className="my-divider" dashed orientation="left">
            Detail - {d.member_id || 0}
          </Divider>
          <div>
            <Row>
              <Col span={10}>Full Name</Col>
              <Col span={14}>{d.full_name}</Col>
            </Row>
            <Row>
              <Col span={10}>Email</Col>
              <Col span={14}>{d.email}</Col>
            </Row>
            <Row>
              <Col span={10}>Address</Col>
              <Col span={14}>
                {d.company_name + ' ' + d.address}
                <br />
                {d.city + ' ' + d.state}
                <br />
                {d.zip_code}
              </Col>
            </Row>
            <Row>
              <Col span={10}>Tel.</Col>
              <Col span={14}>{memberDetail.tel || '-'}</Col>
            </Row>
            <Row>
              <Col span={10}>Country</Col>
              <Col span={14}>{memberDetail.country || '-'}</Col>
            </Row>
          </div>

          <Divider className="my-divider" dashed orientation="left">
            KYC - {kyc_logs_detail.id || '(No KYC)'}
          </Divider>
          <div>
            <Row>
              <Col span={10}>Service intend to use</Col>
              <Col span={14}>{kyc_logs_detail.service_type || '-'}</Col>
            </Row>
            <Row>
              <Col span={10}>Content type</Col>
              <Col span={14}>{kyc_logs_detail.content_type || '-'}</Col>
            </Row>
            <Row>
              <Col span={10}>Destination country(s) intend to send</Col>
              <Col span={14}>{kyc_logs_detail.destination_country_text || '-'}</Col>
            </Row>
            <Row>
              <Col span={10}>Social media of your product/brand</Col>
              <Col span={14}>{kyc_logs_detail.social_media_text || '-'}</Col>
            </Row>
            <Row>
              <Col span={10}>Message example</Col>
              <Col span={14}>{kyc_logs_detail.message_example || '-'}</Col>
            </Row>
          </div>

          <Divider className="my-divider" dashed orientation="left">
            Other
          </Divider>
          <div>
            <Row>
              <Col span={10}>{approvedLabelTxt + 'By'}</Col>
              <Col span={14}>{adminName}</Col>
            </Row>
            <Row>
              <Col span={10}>{approvedLabelTxt + 'Date (UTC)'}</Col>
              <Col span={14}>{this.convertDateTimeToHuman(d.approved_date)}</Col>
            </Row>
          </div>

          {isPackageTier && (
            <span>
              <Divider className="my-divider" dashed orientation="left">
                Product Package
              </Divider>
              <div>
                <Row>
                  <Col span={10}>Name</Col>
                  <Col span={14}>{this.getBadgePackage(productDetail)}</Col>
                </Row>
                <Row>
                  <Col span={10}>Country</Col>
                  <Col span={14}>{productDetail.CountryAbbr || '-'}</Col>
                </Row>
                <Row>
                  <Col span={10}>Expire (Month)</Col>
                  <Col span={14}>{productDetail.Expire}</Col>
                </Row>
                <Row>
                  <Col span={10}>Unit Price</Col>
                  <Col span={14}>{productDetail.UnitPrice}</Col>
                </Row>
                <Row>
                  <Col span={10}>Credits</Col>
                  <Col span={14}>{productDetail.Quantity}</Col>
                </Row>
              </div>

              {isViberChannelName && (
                <span>
                  <Divider className="my-divider" dashed orientation="left">
                    SID
                  </Divider>
                  <Row>
                    <Col span={10}>Channel Name</Col>
                    <Col span={14}>{d.vbcr.channel_name || '-'}</Col>
                  </Row>
                  <Row>
                    <Col span={10}>Destination Country</Col>
                    <Col span={14}>{this.joinArrStr(d.vbcr.destination_countries)}</Col>
                  </Row>
                </span>
              )}
            </span>
          )}
        </Modal>
        <ResubmitKYCModal
          handleModal={this.handleResubmitKYCModal}
          kycID={kyc_logs_detail.id}
          visible={this.state.visibleResubmitKYCModal}
          kycAdminReasonList={this.props.kycAdminReasonList}
        />
      </div>
    );
  }
}

export default PaymentDetail;



// WEBPACK FOOTER //
// ./src/containers/Payment/payment-detail.modal.js